import { useRef } from 'react';
import { CloseIcon } from './icons';
import { useDialog } from '../hooks/useDialog';
import './Modal.css';

/**
 * Accessible overlay shell used by the photo credits panel.
 * Locks background scrolling, traps Tab, closes on Escape or scrim click, and
 * hands focus back to whatever opened it.
 */
export const Modal = ({ open, onClose, labelledBy, closeLabel = 'Close', size = 'md', children }) => {
  const panelRef = useRef(null);
  useDialog({ open, onClose, containerRef: panelRef });

  if (!open) return null;

  return (
    <div className="tl-modal">
      <div className="tl-modal__scrim" onClick={onClose} data-testid="tl-modal-scrim" />
      <div
        className={`tl-modal__panel tl-modal__panel--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        ref={panelRef}
        tabIndex={-1}
      >
        <button type="button" className="tl-modal__close" onClick={onClose}>
          <CloseIcon size={20} />
          <span className="tl-visually-hidden">{closeLabel}</span>
        </button>
        {children}
      </div>
    </div>
  );
};
